import store from '@/store'
import { listMyTeams } from '@/services/wootdashAgents'

/**
 * Times de que o usuário logado é membro, guardados no store (userTeamIds) — usados pela checagem de permissão
 * por time do sistema antigo de perfis (useAdmin), que guarda os times pelo id numérico do Chatwoot. Vem de
 * GET /agentes/eu/times (WootDash); antes varria times e membros no próprio Chatwoot, que saiu de circulação.
 * Time nascido no WootDash não tem id do Chatwoot e não entra — os perfis antigos não conseguem referenciá-lo.
 */
export async function loadMyTeamIds(): Promise<void> {
  const user = store.getters.authUser
  const token: string | undefined = user?.wootdash_token
  if (!token) return
  const teams = await listMyTeams(token)
  const myTeamIds = teams.map(t => t.chatwootId).filter((id): id is number => id !== null)
  await store.dispatch('setUserTeams', myTeamIds)
}
